import React from 'react';
import styled from 'styled-components';
import {fontSize} from '../mixins';


const StyledInfoText = styled.p`
   ${fontSize(12)};
   line-height: 16px;
   color: ${props => props.color ? props.color : '#6C797D'};
   letter-spacing: -0.28px;
   margin: 5px 0;
`

const InfoText = (props) => (
    <StyledInfoText color={props.color}>
        {props.children}
    </StyledInfoText>
);


export default InfoText;